import { httpClient } from '../httpClient/httpClient';
import {
  AutoUpdateRequestWithData,
  AutoUpdateResponse,
} from './autoUpdateTypes';

export interface CompositionGroupTemplatePrice {
  id: number;
  compositionGroupPurchaseInfoId: number;
  purchasePrice: number;
  salesPrice: number;
  branchRegionId: number;
  templateRangeTierId: number;
}

export interface AutoUpdateTemplatePrice {
  purchasePrice?: number;
  salesPrice?: number;
}

export interface AutoUpdateTemplatePriceAdditionalData {
  compositionGroupPurchaseInfoId: number;
  branchRegionId: number;
  templateRangeTierId: number;
}

export const EMPTY_AUTO_UPDATE_TEMPLATE_PRICE_OBJECT: AutoUpdateTemplatePrice =
  {
    purchasePrice: 0,
    salesPrice: 0,
  };

export const compositionGroupTemplatePriceApi = {
  getAll: (compositionGroupPurchaseInfoId: number) =>
    httpClient.get<CompositionGroupTemplatePrice[]>(
      `composition-group-template-prices/${compositionGroupPurchaseInfoId}`,
    ),
  autoUpdateTemplatePrice: (
    request: AutoUpdateRequestWithData<
      AutoUpdateTemplatePrice,
      AutoUpdateTemplatePriceAdditionalData
    >,
  ) =>
    httpClient.post<AutoUpdateResponse<CompositionGroupTemplatePrice>>(
      `composition-group-template-prices/auto`,
      { data: request },
    ),
};
